module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu01-d5f6e44dc3647fc89231efdf9e9f9f15.gif";